export const ProjectData = [
  {
    title: "CASCADE",
    problem: "Corporate supply chains often lack transparency and real-time validation of worker conditions.",
    role: "Full-stack Developer",
    keyFeatures: [
      "Real-time worker voice integration",
      "Automated ethical business scoring",
      "Scalable data ecosystem for CSOs"
    ],
    metrics: "Improved data visibility for 50+ global CSOs.",
    description:
      "Cascading Sustainability Data Ecosystem. Better data + better solutions for ethical and sustainable supply chains.",
    detail:
      "CASCADE is a global network of values-aligned, data-driven civil society organizations (CSOs) dedicated to improving the lives of people in supply chains through worker voice, partnership, and innovation. Our goal is to shift corporate focus from risk avoidance to a virtuous cycle of continuous improvement, where ethical business conduct is recognized and incentivized.",
    imgURL: "./screen/cascade/1.png",
    screen: [
      "./screen/cascade/1.png",
      "./screen/cascade/2.png",
      "./screen/cascade/3.png",
      "./screen/cascade/4.png",
      "./screen/cascade/5.png",
    ],
    languages: ["reactjs", "nodejs", "mysql", "sequelize"],
    online: true,
  },
  {
    title: "ILM (Inclusive Labor Monitoring)",
    problem: "Traditional labor monitoring is often reactive and disconnected across borders.",
    role: "Full-stack Engineer",
    keyFeatures: [
      "Secure and cloud-based case management",
      "Real-time visibility into KPIs, Cases, Calls and Ethical Performance Score",
      "Cross-border collaboration tools for Strategic Partners, Suppliers and Recruitment Agencies"
    ],
    metrics: "Reduced response time for worker signals by 40%.",
    description:
      "Worker voice-driven system for monitoring recruitment, working conditions, and remediation in global supply chains.",
    detail:
      `The Inclusive Labor Monitoring (ILM) system is essentially the case management system used by the Issara team and non-profit service provider partners spanning Asia to record and track worker signals and remediation processes in real time. 
On the human side, ILM is an Action Network of non-profit service providers in key producing countries as well as in the home countries where migrant workers originate. The Action Network members collaborate in identifying and intervening on risks, safeguarding workers, and supporting remediation processes.
On the tech side, ILM is a secure, cloud-based case management system for monitoring and maintaining real-time visibility into worker-validated recruitment and working conditions across both origin and destination countries. The data from the ILM system is accessed by companies via the CASCADE platform.`,
    imgURL: "./screen/ilm/1.png",
    screen: [
      "./screen/ilm/1.png",
      "./screen/ilm/2.png",
      "./screen/ilm/3.png",
      "./screen/ilm/4.png",
      "./screen/ilm/5.png",
    ],
    languages: ["reactjs", "python", "mysql", "django"],
    online: true,
  },
  {
    title: "Golden Dreams",
    problem: "Workers often lack access to safe job information and have no way to report exploitation anonymously.",
    role: "Mobile/Frontend Developer",
    keyFeatures: [
      "Anonymous employer ratings & reviews",
      "Multilingual Job Marketplace",
      "Know-your-rights education module"
    ],
    metrics: "100k+ active users across Southeast Asia.",
    description:
      "The smartphone app designed by and for workers that empowers them to find safe jobs and avoid exploitation.",
    detail:
      `Golden Dreams is an award-winning Yelp-like smartphone app designed by and for workers and survivors to search job and support them through migration and employment, providing the information, tools, and voice they need to stay safe and avoid exploitation.
Users can access up-to-date information on migration costs, processes, and worker rights, helping them make informed decisions. The app also features know-your-rights information and anonymous ratings and reviews of employers, recruiters, and service providers, bringing transparency to recruitment decisions. 
Through its multilingual Job Marketplace, ethical employers and agencies can connect directly with job seekers—enabling transparent, broker-free, and fee-free hiring.`,
    imgURL: "./screen/gd/1.png",
    screen: [
      "./screen/gd/1.png",
      "./screen/gd/2.png",
      "./screen/gd/3.png",
      "./screen/gd/4.png",
      "./screen/gd/5.png",
    ],
    languages: ["reactjs", "python", "mysql", "django"],
    online: true,
  },
  {
    title: "JARVIS (IoT Alert System)",
    featured: true,
    problem: "Lack of centralized monitoring for IoT sensors and manual alerting systems caused delays in response.",
    role: "Lead Backend Developer",
    keyFeatures: [
      "Real-time monitoring using MQTT + Socket.io",
      "Multi-channel alerts (Email, SMS, Telegram)",
      "Centralized survey feedback & user management"
    ],
    metrics: "Handled 50+ sensor events per hour with <1s latency.",
    description:
      "IoT devices, sensor alert and centralized survey feedback platform.",
    detail:
      "Developed a robust IoT alert system that integrates real-world sensors with a centralized dashboard. Used Socket.io for real-time data streaming and implemented a complex alerting logic that triggers notifications across multiple platforms when sensor thresholds are breached.",
    imgURL: "./screen/jarvis/1.png",
    screen: [
      "./screen/jarvis/1.png",
      "./screen/jarvis/2.png",
      "./screen/jarvis/3.png",
      "./screen/jarvis/4.png",
      "./screen/jarvis/5.png",
    ],
    languages: ["reactjs", "nodejs", "mysql", "sequelize", "socketio", "mqtt"],
    online: true,
  },
  {
    title: "UNDP",
    description:
      "Sustainable Development Goals and Digital Maturity Assessment Survey Platform.",
    detail:
      "Created Sustainable Development Goal targets monitoring dashboard and Digital Maturity Assessment survey platform.",
    imgURL: "./screen/undp/1.png",
        keyFeatures: [
      "Real-time data visualization and Reporting System",
      "Fast and reliable digital survey platform for different SDG Targets",
      "Support international Languages and handled dynamic survey architecture."
    ],
    screen: [
      "./screen/undp/1.png",
      "./screen/undp/2.png",
      "./screen/undp/3.png",
      "./screen/undp/4.png",
      "./screen/undp/5.png",
    ],
    languages: ["reactjs", "nodejs", "mysql"],
    online: true,
  },
  {
    title: "JARVIS Feedback App",
    description:
      "A survey system for user feedback monitoring of rest rooms and task creation process for cleaners.",
    detail:
      "Developed react native app for the tablets which directly monitor by admin dashboard web platform.",
    imgURL: "./screen/toiletsurvey/2.png",
    keyFeatures: [
      "Manage multiple device signal, data sibmission and alert system",
      "Monitored real-time feedback data, abnormal alert by device",
      "Collaborate with on-site team for device and sensor installation via LoRaWAN gateway"
    ],
    screen: [
      "./screen/toiletsurvey/1.png",
      "./screen/toiletsurvey/2.png",
      "./screen/toiletsurvey/3.png",
      "./screen/toiletsurvey/4.png",
      "./screen/toiletsurvey/5.png",
      "./screen/toiletsurvey/6.png",
      "./screen/toiletsurvey/7.png"
    ],
    languages: ["reactnative", "nodejs", "mysql"],
    online: true,
  },
  {
    title: "CO₂ Emission Tracking and Computing",
    description:
      "Tracking on carbon emission by vehicle raw data and developed visualized dashboard in daily, monthly or yearly.",
    detail:
      "Analyse vehicle sensor raw data and calculate carbon emission including carbon tracking and offset of clients.",
    imgURL: "./screen/co2delete/1.png",
    screen: [
      "./screen/co2delete/1.png",
      "./screen/co2delete/2.png",
      "./screen/co2delete/3.png",
      "./screen/co2delete/4.png",
    ],
    // projectURL: "https://www.co2delete.com",
    languages: ["reactjs", "nodejs", "mysql"],
    online: true,
  },
  {
    title: "Preliminary Assessment Survey",
    description:
      "A digital survey platform for installed chillers, pumps and cooling towers of buildings.",
    detail:
      "Saving and reporting records of surveys answered by users for each building and equipment parameters.",
    imgURL: "./screen/pea/1.png",
    screen: ["./screen/pea/1.png", "./screen/pea/2.png", "./screen/pea/3.png"],
    // projectURL: "http://172.105.123.57:6767",
    languages: ["reactjs", "nodejs", "mysql"],
    online: true,
  },
  {
    title: "Carbon Abatement",
    description:
      "Enviornmental survey platforms and visualized dashboard for carbon emission and reduction.",
    detail:
      "Created Sustainable Development Goal targets monitoring dashboard and Digital Maturity Assessment survey platform.",
    imgURL: "./screen/co2rap/1.png",
    screen: [
      "./screen/co2rap/1.png",
      "./screen/co2rap/2.png",
      "./screen/co2rap/3.png",
      "./screen/co2rap/4.png",
      "./screen/co2rap/5.png",
    ],
    // projectURL: "https://www.co2rap.com",
    languages: ["reactjs", "nodejs", "mongodb"],
    online: true,
  },
  {
    title: "Nyein Hospital",
    description: "A static business website for professional healthcare and hospitality service.",
    detail:
      "Developed and hosted for a local business project for hospital",
    imgURL: "./screen/nyein/1.png",
    // projectURL: "https://www.nyeinhospitalmandalay.com",
    screen: [
      "./screen/nyein/1.png",
      "./screen/nyein/2.png",
      "./screen/nyein/3.png"
    ],
    languages: ["html", "css", "reactjs"],
    online: true,
  },
  {
    title: "Kislev Transportation",
    description: "An e-commerce web page for transportation devices.",
    detail:
      "Created Sustainable Development Goal targets monitoring dashboard and Digital Maturity Assessment survey platform.",
    imgURL: "./screen/assignment/1.png",
    languages: ["reactjs", "html", "css"],
    online: true,
  },
  {
    title: "Footware",
    description: "UI assignment project for shoes gallery.",
    detail: "An e-commerce platform for the sneaker shop.",
    imgURL: "./screen/shoes/1.png",
    languages: ["reactjs", "html", "css"],
    online: true,
  },
  {
    title: "Acbel Solar",
    description: "Tracking on solar energy system input and output data.",
    detail:
      "Created Sustainable Development Goal targets monitoring dashboard and Digital Maturity Assessment survey platform.",
    imgURL: "./screen/acbel/1.png",
    // projectURL: "https://www.acbel.com.tw",
    languages: ["ajax", "jquery"],
    online: true,
  },
];
